import React from 'react';
import Dialog from '@components/atoms/dialog/dialog';
import clsx from 'clsx';
import styles from './consignment-modal.module.scss';

type ConsignmentModalProps = {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  text: string;
};

const ConsignmentModal: React.FC<ConsignmentModalProps> = (props) => {
  const { isOpen, onClose, title, text } = props;

  const handleCloseDialog = () => {
    onClose(false);
  };

  return (
    <Dialog
      isOpen={isOpen}
      closeDialog={() => handleCloseDialog()}
      key={`openConsignmentModal${isOpen}`}
      hasCloseIcon
      styles={{
        content: {
          maxWidth: '600px',
        },
      }}
    >
      {(modalDialogTitleId: string) => (
        <div className={clsx(styles.consignmentModal, 'vc-modal__innerContainer')}>
          <h2
            className={clsx(styles.consignmentModal__title, 'vc-modal__title')}
            id={modalDialogTitleId}
          >
            {title}
          </h2>
          <p className={clsx(styles.consignmentModal__text, 'vc-modal__content')}>{text}</p>
          <button
            type="button"
            onClick={() => handleCloseDialog()}
            className={clsx('vc-btn', 'vc-btn--primary', 'vc-btn--large', styles.consignmentModal__btn)}
          >
            OK
          </button>
        </div>
      )}
    </Dialog>
  );
};

export default ConsignmentModal;
